







































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { PaintingByNumbersModule } from '../../../../store/modules/paintingByNumbers';
import { AppModule } from '../../../../store/modules/app'
import PaintingByNumbersEditorPassive from "@/components/products/malennachzahlen/PaintingByNumbersEditorPassive.vue"
import BoxImageBig from '@/components/products/malennachzahlen/BoxImageBig.vue'
import BoxImageOverlayBig from '@/components/products/malennachzahlen/BoxImageOverlayBig.vue'

@Component({
  name: "box-edit-big",
  components: {
    PaintingByNumbersEditorPassive,
    BoxImageBig,
    BoxImageOverlayBig
  }
})
export default class BoxEditBig extends Vue {
  matrix3d = '0.5360394131,-0.0544435840,0.0000000000,0.0000435955,0.0489187970,0.5668376675,0.0000000000,0.0000561249,0.0000000000,0.0000000000,1.0000000000,0.0000000000,0.0000000000,18.0000000000,0.0000000000,1.0000000000'
  transformedOffsetX: number = 0
  transformedOffsetY: number = 0
  titleColor: string = "rgb(255,255,255)"
  titleOffsetX: number = 0
  titleOffsetY: number = 0
  titleFontSize: string = "8px"
  titleMatrix3d: string = "1.0,0.0,0.0,0.0,0.0,1.0,0.0,0.0,0.0,0.0,1.0,0.0,0.0,0.0,0.0,1.0"

  get showEditorWrapper() {
    return PaintingByNumbersModule.showBoxEdit
  }

  get isLandscapeFormat() {
    return PaintingByNumbersModule.isLandscapeFormat
  }

  get isSquare() {
    return this.parts === '100000'
  }

  get imageEditorWidth() {
    return PaintingByNumbersModule.imageEditorWidth
  }

  get imageEditorHeight() {
    return PaintingByNumbersModule.imageEditorHeight
  }

  get title() {
    return PaintingByNumbersModule.title;
  }

  get designNr() {
    return PaintingByNumbersModule.boxDesign
  }

  get parts() {
    return PaintingByNumbersModule.parts
  }

  get dru1AssetId() {
    return PaintingByNumbersModule.previewAssetId
  }

  get imageAssetId() {
    let usage = "paintingimage"
    let info = PaintingByNumbersModule.paintingUsageAndInfo[usage]
    if (info) {
      let onlyAssetId = info.assetId
      if (onlyAssetId !== undefined) {
        return onlyAssetId
      }
    }
    return ''
  }

  get paintingBoxUpdateState() {
    return PaintingByNumbersModule.paintingBoxUpdateState
  }

  get sessionId(): string {
    return AppModule.session.sessionId as string
  }

  get locale(): string {
    return AppModule.session.locale as string
  }

  get availableDesigns() {
    return PaintingByNumbersModule.availableDesigns
  }

  setImgAndTitle() {
    this.setUserImg()
    this.setTitleTransform()
  }

  setUserImg() {
    this.setMatrix3d()
    this.setTransformedOffsetX()
    this.setTransformedOffsetY()
  }

  setTitleTransform() {
    this.setTitleOffsetX()
    this.setTitleOffsetY()
    this.setTitleFontSize()
    this.setTitleMatrix3d()
    this.setTitleColor()
  }

  setMatrix3d() {
    if (this.parts === '100000') {
      this.matrix3d = '0.5343268271,-0.0542696428,0.0000000000,0.0000434562,0.0487625069,0.5650266845,0.0000000000,0.0000559456,0.0000000000,0.0000000000,1.0000000000,0.0000000000,0.0000000000,18.0000000000,0.0000000000,1.0000000000'
    } else if (this.parts === '100001') {
      if (!this.isLandscapeFormat) {
        this.matrix3d = '0.4211429516,-0.0311445271,0.0000000000,0.0000678118,0.0382997325,0.3951803459,0.0000000000,0.0000533155,0.0000000000,0.0000000000,1.0000000000,0.0000000000,0.0000000000,13.0000000000,0.0000000000,1.0000000000'
      } else {
        this.matrix3d = '0.4783005570,-0.0437500000,0.0000000000,0.0000320994,0.0438014029,0.4866856840,0.0000000000,0.0000634504,0.0000000000,0.0000000000,1.0000000000,0.0000000000,0.0000000000,14.0000000000,0.0000000000,1.0000000000'
      }
    } else {
      this.matrix3d = '1.0,0.0,0.0,0.0,0.0,1.0,0.0,0.0,0.0,0.0,1.0,0.0,0.0,0.0,0.0,1.0'
    }
  }

  setTitleColor() {
    for (let i = 0; i < this.availableDesigns.length; i++) {
      for (let j = 0; j < this.availableDesigns[i].length; j++) {
        if (this.availableDesigns[i][j].designNr === this.designNr) {
          let titleColor = this.availableDesigns[i][j].titleColor
          if (titleColor) {
            this.titleColor = '#' + titleColor
          }
        }
      }
    }
  }

  setTransformedOffsetX() {
    if (this.parts === '100000') {
      this.transformedOffsetX = 189.5
    } else if (this.parts === '100001') {
      if (!this.isLandscapeFormat) {
        this.transformedOffsetX = 134.5
      } else {
        this.transformedOffsetX = 227
      }
    } else {
      this.transformedOffsetX = 0
    }
  }

  setTransformedOffsetY() {
    if (this.parts === '100000') {
      this.transformedOffsetY = 103
    } else if (this.parts === '100001') {
      if (!this.isLandscapeFormat) {
        this.transformedOffsetY = 352
      } else {
        this.transformedOffsetY = 302.5
      }
    } else {
      this.transformedOffsetY = 0
    }
  }

  setTitleOffsetX() {
    if (this.parts === '100000') {
      this.titleOffsetX = 26
    } else if (this.parts === '100001') {
      if (!this.isLandscapeFormat) {
        this.titleOffsetX = 9
      } else {
        this.titleOffsetX = 9
      }
    }
  }

  setTitleOffsetY() {
    if (this.parts === '100000') {
      this.titleOffsetY = 347
    } else if (this.parts === '100001') {
      if (!this.isLandscapeFormat) {
        this.titleOffsetY = 314.5
      } else {
        this.titleOffsetY = 311.5
      }
    }
  }

  setTitleFontSize() {
    if (this.parts === '100000') {
      this.titleFontSize = '8px'
    } else if (this.parts === '100001') {
      if (!this.isLandscapeFormat) {
        this.titleFontSize = '4px'
      } else {
        this.titleFontSize = '5px'
      }
    }
  }

  setTitleMatrix3d() {
    if (this.parts === '100000') {
      this.titleMatrix3d = '1.0000000000,-0.1309523810,0.0000000000,0.0000000000,0.0000000000,1.0000000000,0.0000000000,0.0000000000,0.0000000000,0.0000000000,1.0000000000,0.0000000000,0.0000000000,0.0000000000,0.0000000000,1.0000000000'
    } else if (this.parts === '100001') {
      if (!this.isLandscapeFormat) {
        this.titleMatrix3d = '1.0000000000,-0.1142857143,0.0000000000,0.0000000000,0.0000000000,1.0000000000,0.0000000000,0.0000000000,0.0000000000,0.0000000000,1.0000000000,0.0000000000,0.0000000000,0.0000000000,0.0000000000,1.0000000000'
      } else {
        this.titleMatrix3d = '1.0000000000,-0.1119047619,0.0000000000,0.0000000000,0.0000000000,1.0000000000,0.0000000000,0.0000000000,0.0000000000,0.0000000000,1.0000000000,0.0000000000,0.0000000000,0.0000000000,0.0000000000,1.0000000000'
      }
    }
  }

  mounted() {
    const imgBoxBig = document.getElementById('imgBoxBig')
    if (imgBoxBig) {
      imgBoxBig.addEventListener('load', this.setImgAndTitle)
    }
    this.setImgAndTitle()
    if (navigator.userAgent.match(/(iPhone|iPad|Android)/)) {
      const collageWrapper = document.getElementById('editorWrapper');
      if (collageWrapper && !collageWrapper.classList.contains('rv-blur')) {
        collageWrapper.classList.add('rv-blur');
      }
    }
  }

  beforeDestroy() {
    const imgBoxBig = document.getElementById('imgBoxBig')
    if (imgBoxBig) {
      imgBoxBig.removeEventListener('load', this.setImgAndTitle)
    }
  }
}
